/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.group {
  display: grid;
}
.button {
  padding-inline: calc(var(--spacing, 0.25rem) * 4);
  border-style: var(--tw-border-style);
  border-width: 1px;
  --tw-border-style: solid;
  border-style: solid;
  border-color: var(--color-gray-500, #737373);
  background-color: var(--color-white, #fff);
  color: var(--color-emphasis-medium, #525252);
  white-space: nowrap;
  cursor: pointer;
}
.button:first-child {
  border-top-left-radius: var(--radius-sm, 0.25rem);
  border-bottom-left-radius: var(--radius-sm, 0.25rem);
}
.button:last-child {
  border-top-right-radius: var(--radius-sm, 0.25rem);
  border-bottom-right-radius: var(--radius-sm, 0.25rem);
}
.button:not(:last-child) {
  margin-right: -1px;
}
.lg {
  height: calc(var(--spacing, 0.25rem) * 10);
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
}
.sm {
  height: calc(var(--spacing, 0.25rem) * 8);
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
}
.button[aria-pressed="true"] {
  position: relative;
  border-color: var(--color-primary-500);
  background-color: var(--color-primary-100);
  color: var(--color-primary-500);
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  box-shadow: inset 0 0 0 1px var(--color-primary-500);
}
.button:hover:not([aria-pressed="true"]) {
  background-color: var(--color-gray-100, #f5f5f5);
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
      --tw-font-weight: initial;
    }
  }
}
